<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeTimeOff
 */
import type { BadgeTimeOffProps } from '../types/interfaces'

defineOptions({
  name: 'BadgeTimeOff',
})

withDefaults(defineProps<BadgeTimeOffProps>(), {
  mode: 'info',
})
</script>

<template>
  <span :class="['ui-badge-time-off', `ui-badge-time-off--${mode}`]">
    <slot />
  </span>
</template>

<style lang="scss" scoped src="../styles/_badge-time-off.scss" />
